import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { DELIVERY_SECTION_CALLOUT_VARIANT, CALLOUT_BUBBLE_BACKGROUND } from "./constants";

export const CalloutContainer = styled.div<{ variant?: DELIVERY_SECTION_CALLOUT_VARIANT }>(({ theme, variant }) => {
    if (variant === DELIVERY_SECTION_CALLOUT_VARIANT.TOP_PADDING) {
        return {
            padding: `${theme.spacing.medium} ${theme.spacing.medium} 0`,
        };
    }
    return {
        paddingBottom: theme.spacing.medium,
    };
});

export const CalloutBubble = styled.div(({ theme }) => ({
    background: CALLOUT_BUBBLE_BACKGROUND,
    borderRadius: theme.cornerRadius.small,
    padding: `${theme.spacing.x5} ${theme.spacing.x5}`,
    display: "flex",
    alignItems: "center",
}));

export const CalloutMessage = styled(Text)(() => ({
    flex: 1,
}));
